import RequiresAuth from '@website/components/auth/RequiresAuth';
import CustomBreadcrumb from '@website/components/CustomBreadcrumb';
import ChangePassword from '@website/components/me/userID/ChangePassword';
import ManageUserHostRoles from '@website/components/me/userID/ManageUsersHostRoles';
import UpdateUserForm from '@website/components/me/userID/UpdateUserForm';
import { useRouter } from 'next/router';
import { useContext } from 'react';
import { Col, Container, Tab, Tabs } from 'react-bootstrap';
import { Store } from '../../../Store';

export default function UserEdit() {
  const { query } = useRouter();
  const { state } = useContext(Store);
  const hostAdmin = state.user.roles.includes('admin');
  const { userID } = query;

  return (
    <RequiresAuth>
      <Container>
        <CustomBreadcrumb
          items={[
            { text: 'Home', href: '/' },
            { text: 'Dashboard', href: `/me/${userID}` },
            { text: 'Edit', active: true },
          ]}
        />

        <h1>Edit Your Details</h1>

        <Col xs={12} sm={12} lg={6}>
          <Tabs id="manage-user-profile-tab" defaultActiveKey="profile">
            <Tab eventKey="profile" title="Profile">
              <UpdateUserForm userID={userID} />
            </Tab>
            <Tab eventKey="password" title="Change Password">
              <ChangePassword userID={userID} />
            </Tab>
            {hostAdmin && (
              <Tab eventKey="hostRoles" title="Host Roles (admin)">
                <ManageUserHostRoles userID={userID as string} />
              </Tab>
            )}
          </Tabs>
        </Col>
      </Container>
    </RequiresAuth>
  );
}
